import { createContext } from 'react';
import { AppTypes } from './appTypes';

const appContext = createContext({} as AppTypes);

export default appContext;
